<template>
  <div id="bdm_system" :class="isFull === 1 ? 'creator_country_agency top_information1' : ' creator_country_agency'">
    <van-nav-bar :title="$t('column.bdm_system_title',{name:role_type_title })" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
          <div style="position: relative; display: inline-block;">
            <img src="../assets/img/bdm/ic_status_im_notify.png" alt="" height="20vw" @click="onClickMessage">
            <van-info :info="bdm_messages_total" v-if="bdm_messages_total"/>
          </div>
            
        </template>
    </van-nav-bar>
    <van-row>
      <!--  列表    -->
      <van-col span="22" offset="1" class="bdm_system_list">
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.bdm_center_access" @click="showCenterBtn('bdm_center')">
            <img src="../assets/img/bdm/ic_guanliyuan.png" alt="">
            {{$t('column.bdm_center',{name:'BDM' })}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.admin_center_access" @click="showCenterBtn('admin_center')">
            <img src="../assets/img/bdm/admin_center.png" alt="">
           {{$t('column.admin_center')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.admin_management_access" @click="jumpUrl('bdm_management',2)">
            <img src="../assets/img/bdm/icon_guid.png" alt="">
           {{$t('column.admin_management')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.admin_add" @click="showAddBtn('admin_add',1)">
            <img src="../assets/img/bdm/ic_ad_adm.png" alt="">
           {{$t('column.admin_add')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.coin_seller_management_access" @click="jumpUrl('bdm_seller_management',0)">
            <img src="../assets/img/bdm/coin_merchant.png" alt="">
          {{$t('column.coin_seller_management')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.coin_seller_add" @click="showAddBtn('coin_seller_add',4)">
            <img src="../assets/img/bdm/ic_ad_cs.png" alt="">
           {{$t('column.coin_seller_add')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.payroll_request" @click="jumpUrl('bdm_payroll_management',0)">
            <img src="../assets/img/bdm/ic-pr.png" alt="">
           {{$t('column.payroll_request')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.bd_center_assess" @click="showCenterBtn('bd_center')">
            <img src="../assets/img/bdm/ic_bd.png" alt="">
           {{$t('column.bd_center')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.bd_management_access"  @click="jumpUrl('bdm_management',3)">
            <img src="../assets/img/bdm/ic_in_bd.png" alt="">
           {{$t('column.bd_management')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.bd_invite" @click="showAddBtn('bd_invite',2)">
            <img src="../assets/img/bdm/ic_ad_cs.png" alt="">
           {{$t('column.bd_invite')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.agc_management_access" @click="jumpUrl('bdm_management',4)">
            <img src="../assets/img/bdm/ic_agc_mang.png" alt="">
           {{$t('column.agc_management')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.agc_invite" @click="showAddBtn('agc_invite',3)">
            <img src="../assets/img/bdm/ic_ad_adm.png" alt="">
           {{$t('column.agc_invite')}}
        </van-col>


        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.agc_center_assess" @click="showCenterBtn('agc_center')">
            <img src="../assets/img/bdm/ic_agc.png" alt="">
           {{$t('column.agc_center')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.host_management_access" @click="jumpUrl('bdm_host_management',0)">
            <img src="../assets/img/bdm/ic_hs.png" alt="">
          {{$t('column.host_management')}}
        </van-col>
         <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.host_invite" @click="showInviteHostBtn">
            <img src="../assets/img/bdm/ic_ad_adm.png" alt="">
          {{$t('column.invite_host')}}
        </van-col>
         <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.agc_name_save" @click="showModifyAgcNameBtn()">
            <img src="../assets/img/bdm/share_moment.png" alt="">
            {{$t('column.modify_agc_name')}}
        </van-col>
        <van-col span="22" offset="1" class="bdm_system_list_item" v-if="permission.agc_policy" @click="jumpUrl('creator_agency_apply_details',0)">
            <img src="../assets/img/bdm/order_msg_icon.png" alt="">
            {{$t('column.policy')}}
        </van-col>
      </van-col>

      <van-col span="22" offset="1" class="bdm_system_bottom" v-if="permission.distribute_reward" @click="jumpUrl('bdm_distribute_reward',0)">
         <img src="../assets/img/bdm/ic_dr.png" alt="">
         {{$t('column.distribute_reward')}}
      </van-col>


      <van-popup v-model="showAdd" class="add-admin-popup" round>
        <div class="popup-header">
          <span class="popup-title">{{  popup_title }}</span>
          <div class="close-btn" @click="showAdd = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="popup-content">
          <div class="manual-invite-title">{{$t('column.manual_invite')}}</div>
          <div class="form-item">
            <div class="label">{{$t('column.inviter_user_id')}}</div>
            <input type="text" :placeholder="$t('column.enter_user_id')" class="input-field" v-model="inviterId" />
          </div>
          <div class="form-item">
            <div class="label">{{$t('column.meno_verification_code')}}</div>
            <div class="input-group">
              <input type="text" :placeholder="$t('column.enter_inviter_received_code')" class="input-field" v-model="verificationCode" />
               <van-button size="small" round color="#ff6b9e" class="get-btn" :disabled="countdown > 0" @click="getCode">{{ countdown > 0 ? countdown + 's' : $t('column.get_code') }}</van-button>
            </div>
          </div>
          <div class="limit-section" v-if="(addType === 'admin_add' && bdm_administrator_restrictions) || (addType === 'coin_seller_add' && bdm_coin_seller_restrictions)">
            <div class="progress-bar">
              <div class="progress" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="limit-text">{{ addType === 'admin_add' ? admin_number : coin_seller_number }}/{{ addType === 'admin_add' ? bdm_administrator_restrictions : bdm_coin_seller_restrictions }} {{ addType === 'admin_add' ? $t('column.admin_limit') : $t('column.coin_sellers_limit') }}</div>
          </div>

          <button class="confirm-btn" :class="{ 'disabled': !inviterId || !verificationCode }" :disabled="!!(!inviterId || !verificationCode)" @click="confirmAdd">{{$t('btn.confirm')}}</button>
        </div>
      </van-popup>
      <van-popup v-model="showPayroll" class="payroll-popup" round>
        <div class="payroll-header">
          <div class="payroll-title">{{  popup_title }}</div>
          <div class="payroll-close-btn" @click="showPayroll = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="payroll-content">
          <div class="payroll-form-item">
            <div class="payroll-label">{{$t('column.inviter_user_id')}}</div>
            <input type="text" :placeholder="$t('column.enter_user_id')" class="payroll-input-field" v-model="inviterId" />
          </div>
          <button class="payroll-confirm-btn" :class="{ 'disabled': !inviterId }" :disabled="!!(!inviterId)" @click="confirmPayrollAdd">{{$t('column.confirm_request')}}</button>
        </div>
      </van-popup>
      <van-popup v-model="showModifyAgcName" class="payroll-popup" round>
        <div class="payroll-header">
          <div class="payroll-title">{{$t('column.modify_agc_name')}}</div>
          <div class="payroll-close-btn" @click="showModifyAgcName = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="payroll-content">
          <div class="payroll-form-item">
            <input type="text" :placeholder="$t('column.Agent_name')" class="payroll-input-field" v-model="AgentName" />
          </div>
          <button class="payroll-confirm-btn" :class="{ 'disabled': !AgentName }" :disabled="!!(!AgentName)" @click="confirmModifyAgcName">{{$t('column.confirm_request')}}</button>
        </div>
      </van-popup>

      <van-popup v-model="showInviteHost" class="invite-host-popup" round>
        <div class="invite-host-header">
          <span class="invite-host-title">{{ $t('column.invite_host') }}</span>
          <div class="invite-host-close-btn" @click="showInviteHost = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="invite-host-content">
          <div class="invite-host-form-item">
            <div class="invite-host-label">{{$t('column.user_id') || 'User ID'}}</div>
            <input type="text" :placeholder="$t('column.enter_user_id')" class="invite-host-input-field" v-model="inviterId" />
          </div>
          <div class="invite-host-form-item">
            <div class="invite-host-label">{{$t('column.host_code') || 'Host Code'}}</div>
            <input type="text" :placeholder="$t('column.enter_host_code')" class="invite-host-input-field" v-model="hostCode" />
            <van-button size="small" round color="#ff6b9e" class="get-btn" :disabled="countdown > 0" @click="getCode">{{ countdown > 0 ? countdown + 's' : $t('column.get_code') }}</van-button>
          </div>

          <button class="invite-host-confirm-btn" :class="{ 'disabled': !inviterId || !hostCode }" :disabled="!!(!inviterId || !hostCode)" @click="confirmInviteHost">{{$t('btn.confirm')}}</button>
        </div>
      </van-popup>

      <van-overlay :show="loading" z-index="2003">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      permission: {
        'bdm_center_access': 0,
        'admin_center_access': 0,
        'admin_management_access': 0,
        'admin_add': 0,
        'bd_center_assess': 0,
        'bd_management_access': 0,
        'bd_invite': 0,
        'agc_center_assess': 0,
        'agc_management_access': 0,
        'agc_invite': 0,
        'distribute_reward': 0,
        'payroll_request': 0,
        'coin_seller_management_access': 0,
        'coin_seller_add': 0,
        'host_management_access': 0,
        'host_management': 0,
        'host_invite': 0,
        'agc_name_save': 0,
        'agc_policy': 0,
      },
      bdm_info:{},
      loading: false,
      finished: false,
      showAdd: false,
      showPayroll: false,
      showModifyAgcName: false,
      showInviteHost: false,
      inviterId: '',
      verificationCode: '',
      hostCode: '',
      addType: '',
      roleType: 0,
      bdm_administrator_restrictions: 0,
      bdm_coin_seller_restrictions: 0,
      admin_number:0,
      coin_seller_number: 0,
      progress: 0,
      popup_title: '',
      AgentName: '',    
      bdm_messages_total: 0,
      role_type_title:'',
      countdown: 0,
      timer: null,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      popup_add: false, // 是否弹出添加弹框页面
      hasInitialized: false // 是否已经初始化过
    }
  },
  created() {
     this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    // 检查是否已经初始化过
    const hasInit = sessionStorage.getItem('bdm_system_initialized')
    console.log('hasInit=' + hasInit);
    if (!hasInit) {
      // 第一次进入,执行初始化
      this.hasInitialized = false
      this.query_parameter_processing()
      sessionStorage.setItem('bdm_system_initialized', 'true')
    } else {
      // 页面返回,不执行 query_parameter_processing
      this.hasInitialized = true
    }
    this.get_list()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    query_parameter_processing(){
        const add_type = this.$route.query.add_type ? this.$route.query.add_type : ''
        if(add_type){
          this.roleType = add_type
          switch(this.roleType){
            case '1':
              this.addType = 'admin_add'
              break
            case '2':
              this.addType = 'bd_invite'
              break
            case '3':
              this.addType = 'agc_invite'
              break
            default:
              this.addType = ''
          }
          if(this.addType){
            this.popup_add = true
          }
        }
    },
    onClickLeft() {
      // 拦截关闭h5
      sessionStorage.removeItem('bdm_system_initialized')
      window.location.href="bogolive://exit"
    },
    jumpUrl(name,type){
       this.$router.push({
          path: '/' + name,
          query: {
            type: type,
            token: this.$route.query.token,
            is_full: this.isFull,
            source: 'h5',
            is_navigation_bar: 1
          }
        })
    },
    onClickMessage(){
      this.$router.push({
        path: '/bdm_message',
        query: {
          token: this.$route.query.token,
          is_full: this.isFull,
          source: 'h5'
        }
      })
    },
    showCenterBtn(centerType) {
      if (centerType == 'agc_center'){
        this.$router.push({
          path: '/agc_center',
          query: {
            center_type: centerType,
            token: this.$route.query.token,
            is_full: this.isFull,
            source: 'h5'
          }
        })
      }else{
        this.$router.push({
          path: '/bdm_center',
          query: {
            center_type: centerType,
            token: this.$route.query.token,
            is_full: this.isFull,
            source: 'h5'
          }
        })
      }
    },
    getCode() {
      if (this.countdown > 0) return
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_verify_code", {
        params : {
            to_user_id: this.inviterId,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
    Jump_intercept(item) {
      sessionStorage.removeItem('bdm_system_initialized')
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },
    showAddBtn(type,role_type) {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        this.countdown = 0
        this.addType = type
        this.roleType = role_type
        this.inviterId = ''
        this.verificationCode = ''
        this.progress = this.addType === 'admin_add' ? this.admin_number / this.bdm_administrator_restrictions * 100 : this.coin_seller_number / this.bdm_coin_seller_restrictions * 100
        this.popup_title = this.$t('column.' + this.addType)
        this.showAdd = true
    },
    showAddPayrollBtn(){
      this.inviterId = ''
      this.popup_title = this.$t('column.payroll_request')
      this.showPayroll = true
    },
    showModifyAgcNameBtn(){
      this.showModifyAgcName = true
    },
    confirmModifyAgcName(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=save_agc_name", {
        params : {
            agc_name: this.AgentName,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showModifyAgcName = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    showInviteHostBtn() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countdown = 0
      this.inviterId = ''
      this.hostCode = ''
      this.showInviteHost = true
    },
    confirmInviteHost() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=invite_host", {
        params : {
            to_user_id: this.inviterId,
            verify_code: this.hostCode,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showInviteHost = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    confirmPayrollAdd(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=apply_settlement", {
        params : {
            to_user_id: this.inviterId,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showPayroll = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    confirmAdd() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=add_bdm", {
        params : {
            to_user_id: this.inviterId,
            verify_code: this.verificationCode,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showAdd = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_list",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.permission = res.data.data.permission
          this.bdm_info = res.data.data.bdm_info
          this.bdm_administrator_restrictions = res.data.data.bdm_administrator_restrictions
          this.bdm_coin_seller_restrictions = res.data.data.bdm_coin_seller_restrictions
          this.admin_number = res.data.data.admin_number
          this.coin_seller_number = res.data.data.coin_seller_number
          this.AgentName = res.data.data.agc_title
          this.bdm_messages_total = res.data.data.bdm_messages_total
          this.role_type_title = res.data.data.role_type_title
          this.finished = true
          this.loading = false
          if(this.popup_add){
            this.popup_add = false
            this.showAddBtn(this.addType, this.roleType)
          }
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/bdm_system.vue